// pieces and components
const initAccordions = () => {
	const toggleAccordion = (accordion, closeSiblings) => {
		const accordionContent = accordion.querySelector('.accordion-content');

		if (closeSiblings) {
			getSiblings(accordion).forEach((item) => {
				if (item.classList.contains('is-expanded')) {
					toggleAccordion(item, false);
				}
			});
		}

		accordion.classList.toggle('is-expanded');

		if (accordion.classList.contains('is-expanded')) {
			accordion.setAttribute('aria-expanded', true);
			accordionContent.setAttribute('aria-hidden', false);
			accordionContent.style.height = `${accordionContent.querySelector('.content-interior').clientHeight
				}px`;
		} else {
			accordion.setAttribute('aria-expanded', false);
			accordionContent.setAttribute('aria-hidden', true);
			accordionContent.style.height = '0px';
		}
	};

	on('button', 'click', '.js-toggle-accordion', (e) => {
		let accordion = e.target.closest('.comp-accordion');
		toggleAccordion(
			accordion,
			accordion.classList.contains('is-close-siblings')
		);
	});
};

const initItemQuantity = () => {
	on('body', 'click', '[data-quantity-trigger]', e => {
		let target = e.target.dataset.quantityTrigger
			? e.target
			: e.target.closest('[data-quantity-trigger]');
		let itemQuantity = target.closest('.item-quantity');
		let quantityInput = itemQuantity.querySelector('input[name="quantity"]');
		let inputDecrease = itemQuantity.querySelector(
			'[data-quantity-trigger="decrease"]'
		);
		let inputIncrease = itemQuantity.querySelector(
			'[data-quantity-trigger="increase"]'
		);
		let updatedValue =
			parseInt(quantityInput.value) +
			(target.dataset.quantityTrigger == 'increase'
				? parseInt(quantityInput.value) + 1 <= parseInt(quantityInput.max)
					? 1
					: 0
				: parseInt(quantityInput.value) - 1 >= parseInt(quantityInput.min)
					? -1
					: 0);

		updatedValue <= quantityInput.min
			? inputDecrease.classList.add('is-inactive')
			: inputDecrease.classList.remove('is-inactive');

		updatedValue >= quantityInput.max
			? inputIncrease.classList.add('is-inactive')
			: inputIncrease.classList.remove('is-inactive');

		quantityInput.value = target.classList.contains('has-leading-zero')
			? formatLeadingZero(updatedValue)
			: updatedValue;
	});
};

const initFields = () => {
	const fields = document.querySelectorAll('.field');

	fields.forEach(item => {
		let input = item.querySelector(`input[type="text"],
			input[type="email"], 
			input[type="tel"],
			input[type="url"],
			input[type="password"],
			input[type="file"],
			textarea`);
		let determineHasValue = () => {
			input.value
				? item.classList.add('has-value')
				: item.classList.remove('has-value');
		};

		if (input) {
			determineHasValue();
			input.addEventListener('change', determineHasValue);
			input.addEventListener('blur', determineHasValue);
		}
	});
};

const initFlickitySlider = () => {
	const flickitySlider = document.querySelectorAll('[data-flickity-slider]');

	const flickitySliderTrigger = () => {
		flickitySlider.forEach((el) => {
			let flickity = new Flickity(
				el,
				JSON.parse(el.dataset.flickitySlider.replace(/'/g, '"').trim())
			);
			let childrenWidth = Object.values(
				el.querySelector('.flickity-slider').childNodes
			).reduce(
				(total, i) =>
					i.offsetWidth
						? total +
						i.offsetWidth +
						parseInt(window.getComputedStyle(i).marginLeft) +
						parseInt(window.getComputedStyle(i).marginRight)
						: total,
				0
			);

			if (
				// if total children width is lesser than slider width
				el.getBoundingClientRect().width >= childrenWidth ||
				// if flickity slider has breakpoint set, and window is greater than breakpoint
				(el.dataset.flickityBreakpoint &&
					window.innerWidth > parseInt(el.dataset.flickityBreakpoint))
			) {
				// destroy flickity
				flickity.destroy();
				el.classList.add('flickity-disabled');

				setTimeout(() => {
					el.querySelectorAll('[style*="left:"]').forEach((item) => {
						item.style.setProperty('left', 'unset');
					});
				}, 100);
			} else {
				// avoid click on drag: https://github.com/metafizzy/flickity/issues/838
				flickity.on('dragStart', () =>
					flickity.slider.childNodes.forEach(
						(slide) => (slide.style.pointerEvents = 'none')
					)
				);

				flickity.on('dragEnd', () =>
					flickity.slider.childNodes.forEach(
						(slide) => (slide.style.pointerEvents = 'all')
					)
				);
			}

			// child height equalizer
			if (el.classList.contains('flickity-child-is-equal-height')) {
				let maxHeight = [];
				let slider = el.querySelector('.flickity-slider')
					? el.querySelector('.flickity-slider') : el;

				Array.from(slider.children).forEach((item) => {
					maxHeight.push(item.offsetHeight);
				});

				Array.from(slider.children).forEach((item) => {
					item.style.height = `${Math.max.apply(Math, maxHeight)}px`;
				});
			}
		});
	};

	flickitySliderTrigger();
	window.addEventListener('resize', flickitySliderTrigger);

	// swipe fix for IOS
	var touchingCarousel = false;
	var touchStartCoords;

	document.body.addEventListener('touchstart', function (e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY,
		};
	});

	document.body.addEventListener(
		'touchmove',
		function (e) {
			if (!(touchingCarousel && e.cancelable)) {
				return;
			}

			var moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y,
			};

			if (Math.abs(moveVector.x) > 7) {
				e.preventDefault();
			}
		},
		{
			passive: false,
		}
	);
};

const initLoadingBar = (stage) => {
	const loadingBar = document.querySelector('.global-loading-bar');
	const action = (loadingBar.style.opacity == 1 && stage != 'done')
		? 'move' : stage

	switch (action) {
		case 'start':
			loadingBar.style.opacity = 1;
			loadingBar.style.width = window.innerWidth * (Math.floor(Math.random() * 6) + 1) / 10 + 'px';
			break;

		case 'move':
			loadingBar.style.opacity = 1;
			loadingBar.style.width = loadingBar.getBoundingClientRect().width * 1.15 + 'px';
			break;

		case 'done':
			loadingBar.style.width = window.innerWidth + 'px';

			setTimeout(function () {
				loadingBar.style.opacity = 0;
			}, 400);

			setTimeout(function () {
				loadingBar.style.width = 0;
			}, 800);
			break;
	}
}

// global elements and pages

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach(item => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			(item.href.split('#')[1] &&
				item.href.split('#')[0] == window.location.href.split('#')[0])
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		} else {
			item.rel = 'noopener';
			item.target = item.target || '_blank';
		}
	});

	on('body', 'click', '[data-page-transition]', e => {
		let target = e.target.hasAttribute('data-page-transition')
			? e.target
			: e.target.closest('[data-page-transition]');

		target.blur();

		if (
			target.dataset.pageTransition == 'internal' &&
			!root.classList.contains('key-is-down')
		) {
			e.preventDefault();
			root.classList.remove(
				'header-is-sticky',
				'megamenu-is-active',
				'minicart-is-active',
				'header-menu-active',
				'products-aside-is-active',
				'mobile-menu-is-active'
			);

			root.classList.add('is_leaving');

			setTimeout(() => {
				location.href = target.href;
			}, 400);
		} else if (target.dataset.pageTransition == 'scroll') {
			e.preventDefault();
			seamless.elementScrollIntoView(
				document.querySelector(`#${target.href.split('#')[1]}`),
				{
					behavior: 'smooth',
				}
			);
		}
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-animate]').forEach(item => {
		let observer = new IntersectionObserver(
			el => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');
				}
			},
			{
				root: null,
				threshold: [0.2], // 0 = page start; 1 = page bottom, items only revealed when in full view
			}
		);

		observer.observe(item);
	});
};

const initHeader = () => {
	// header scroll
	let header = document.querySelector('.global-header');
	let headerCloned = header.cloneNode(true);
	headerCloned.classList.add('is-cloned');
	document.querySelector('body').appendChild(headerCloned);

	lastScrollTop = 0;
	const headerScroll = () => {
		isScrollingUpwards = scrollY < lastScrollTop
			? true : false;
		lastScrollTop = scrollY <= 0 ? 0 : scrollY; // For Mobile or negative scrolling
		if(!root.classList.contains('mobile-menu-is-active')){
			if(scrollY > innerHeight * 0.5 && isScrollingUpwards){
				root.classList.add('header-is-sticked');
				root.querySelectorAll('.custom-nav-menu-logo--sticky').forEach(el => el.classList.remove('dn-i'));
				root.querySelectorAll('.custom-nav-menu-logo--regular').forEach(el => el.classList.add('dn-i'));
			}else{
				root.classList.remove('header-is-sticked');
				root.querySelectorAll('.custom-nav-menu-logo--sticky').forEach(el => el.classList.add('dn-i'));
				root.querySelectorAll('.custom-nav-menu-logo--regular').forEach(el => el.classList.remove('dn-i'));
			}
		}
	}

	headerScroll();
	window.addEventListener('scroll', headerScroll);

	// megamenu
	const megamenusClose = () => {
		root.classList.remove('megamenu-is-active');

		document.querySelectorAll('[data-megamenu].is-active').forEach(menu => {
			menu.classList.remove('is-active');
		});

		document.querySelectorAll('.is-megamenu-active').forEach(el => {
			el.closest('li').classList.remove('is-megamenu-active');
		});
	};

	setTimeout(() => {
		if (isTablet) return false;

		document.querySelectorAll('[data-megamenu-toggle]').forEach(el => {
			el.dataset.pageTransition == 'none';
			el.removeAttribute('data-page-transition');
		});
	});

	on('body', 'click', '[data-megamenu-toggle]', e => {
		if (isTablet) return false;
		e.preventDefault();
		let target = e.target.closest('[data-megamenu-toggle');

		root.classList.toggle('megamenu-is-active');

		target.closest('li').classList.toggle('is-megamenu-active');

		target.closest('.global-header')
			.querySelector(`[data-megamenu=${target.dataset.megamenuToggle}]`)
			.classList.toggle('is-active');
	});

	on('body', 'click', '.js-megamenu-close', megamenusClose);

	// mobile interactions
	on('body', 'click', '.js-mobile-menu-open', e => {
		e.target.closest('.global-header').classList.add('mobile-menu-is-active');
		root.classList.toggle('mobile-menu-is-active');
	});

	on('body', 'click', '.js-mobile-menu-close', e => {
		e.target.closest('.global-header').classList.remove('mobile-menu-is-active');
		root.classList.remove('mobile-menu-is-active');
	});

	// tablet + mobile inject HTML structures
	if (isTablet) {
		const mobileMegamenuBlocks = document.querySelectorAll('.mobile-menu .menu-megamenu-blocks');

		mobileMegamenuBlocks.forEach(el =>
			el.appendChild(document.querySelector('.megamenu-blocks').cloneNode(true)));
	}

	// mobile menu links
	const toggleAccordion = (accordion, closeSiblings) => {
		const accordionContent = accordion.querySelector('.menu-links');

		if (closeSiblings) {
			getSiblings(accordion).forEach((item) => {
				if (item.classList.contains('is-expanded')) {
					toggleAccordion(item, false);
				}
			});
		}

		accordion.classList.toggle('is-expanded');

		if (accordion.classList.contains('is-expanded')) {
			accordion.setAttribute('aria-expanded', true);
			accordionContent.setAttribute('aria-hidden', false);
			accordionContent.style.height = `${accordionContent.querySelector('ul').clientHeight
				}px`;
		} else {
			accordion.setAttribute('aria-expanded', false);
			accordionContent.setAttribute('aria-hidden', true);
			accordionContent.style.height = '0px';
		}
	};

	on('body', 'click', '.js-menu-links-toggle', e => {
		e.preventDefault();
		let li = e.target.closest('li');
		toggleAccordion(li, true);
	});
};

const initSearch = () => {
	on('body', 'click', '.js-search-toggle', e => {
		root.classList.add('search-is-active');
		root.querySelectorAll('.custom-nav-logo--search').forEach(el => el.classList.remove('dn-i'));
		root.querySelectorAll('.custom-nav-logo--regular').forEach(el => el.classList.add('dn-i'));
		document
			.querySelector('.global-search')
			?.querySelector('input[type="text"]')
			.focus();
	});

	on('body', 'click', '.js-search-open', e => {
		root.classList.add('search-is-active');
		root.querySelectorAll('.custom-nav-logo--search').forEach(el => el.classList.remove('dn-i'));
		root.querySelectorAll('.custom-nav-logo--regular').forEach(el => el.classList.remove('dn-i'));
	});

	on('body', 'click', '.js-search-close', e => {
		root.classList.remove('search-is-active');
		root.querySelectorAll('.custom-nav-logo--search').forEach(el => el.classList.add('dn-i'));
		root.querySelectorAll('.custom-nav-logo--regular').forEach(el => el.classList.remove('dn-i'));
	});

	on('body', 'click', 'body', e => {
		if (
			!e.target.closest('.global-search') &&
			!e.target.classList.contains('.global-search') &&
			!e.target.closest('.js-search-toggle') &&
			!e.target.classList.contains('.js-search-toggle') &&
			!e.target.closest('.js-search-open') &&
			!e.target.classList.contains('.js-search-open')
		) {
			root.classList.remove('search-is-active');
			root.querySelectorAll('.custom-nav-logo--search').forEach(el => el.classList.add('dn-i'));
			root.querySelectorAll('.custom-nav-logo--regular').forEach(el => el.classList.remove('dn-i'));
		}
	});
};

const initContentLayout = () => {
	let contentLayout = document.querySelector('.content-layout');

	if (!contentLayout) return false;

	// iframe fit vids
	reframe(
		'.content-layout iframe[src*="vimeo.com"], .content-layout iframe[src*="youtube.com"]',
		'video-reframe'
	);

	// remove all <meta charset="utf-8">
	contentLayout.querySelectorAll('meta[charset]').forEach(el => {
		el.remove();
	});

	// unwrap image from paragraph tag + wrap around div container
	if (contentLayout) {
		[].forEach.call(contentLayout.getElementsByTagName('img'), function (img) {
			let p = img.closest('p');

			if (p && p.parentElement) {
				p.parentElement.insertBefore(img, p);
				p.parentElement.removeChild(p);
			}

			if (img.parentElement.style.cssText.includes('text-align: center;')) {
				img.parentElement.classList.add('content-image-full');
			} else if (img.parentElement.style.cssText.includes('text-align: right;')) {
				img.parentElement.classList.add('content-image-aside');
			}

			let div = document.createElement('div');
			div.classList.add('image');
			img.parentNode.insertBefore(div, img.nextSibling);
			div.appendChild(img);

			if (img.alt) {
				let divCaption = document.createElement('div');
				divCaption.classList.add('image-caption', 't-b-2');
				divCaption.innerText = img.alt;
				div.appendChild(divCaption);
			}
		});
	}

	// instagram aspect ratio
	let instagramEmbed = document.querySelectorAll('iframe.instagram-media');
	instagramEmbed.forEach(el => {
		el.addEventListener('load', () => {
			setTimeout(() => {
				el.style.height = `${el.getAttribute('height')}px`;
			}, 1500);
		});
	});
};

const initCart = () => {
	// cart visibility
	const minicartClose = () => {
		root.classList.remove('minicart-is-active');
		history.pushState(null, null, ' ');
		scrollEnable();
	};

	const minicartOpen = () => {
		root.classList.add('minicart-is-active');
		history.pushState(null, null, '#cart');
		scrollDisable();
	};

	on('body', 'click', '.js-minicart-open', e => {
		root.classList.contains('minicart-is-active')
			? minicartClose()
			: minicartOpen();
	});

	on('body', 'click', '.js-minicart-close', e => {
		minicartClose();
	});

	document.addEventListener('keydown', e => {
		if (e.key == 'Escape') {
			minicartClose();
		}
	});

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		minicartOpen();
	}

	// updates both cart price and item count
	this.reloadCartData = () => {
		fetch('/cart.js')
			.then(response => {
				return response.json();
			})
			.then(data => {
				let minicartContent = document.querySelector('.minicart-content');

				// update global cart states
				let enactStateChange = ((parseInt(document.querySelector('.cart-total-items').innerText) > 0 &&
					data.item_count == 0) ||
					(parseInt(document.querySelector('.cart-total-items').innerText) == 0 &&
						data.item_count > 0));

				if (enactStateChange) {
					minicartContent.style.animation = 'fadeOut 0.2s var(--a-panel) both';

					setTimeout(() => {
						minicartContent.style.animation = 'fadeIn 0.8s 0.4s var(--a-panel) both';
					}, 400);
				}

				setTimeout(() => {
					(data.item_count > 0)
						? root.classList.add('cart-has-items')
						: root.classList.remove('cart-has-items');
				}, enactStateChange ? 400 : 0);

				document.querySelectorAll('.cart-total-price').forEach(item => {
					item.innerText = `$${parseFloat(data.total_price / 100).toFixed(2)}`;
				});

				document.querySelectorAll('.cart-total-items').forEach(item => {
					item.innerText = data.item_count;
				});

				// free shipping threshold
				let freeshippingThreshold = document.querySelector('[data-freeshipping-threshold]');

				if (freeshippingThreshold) {
					let threshold = parseInt(freeshippingThreshold.dataset.freeshippingThreshold);
					let current = data.total_price / 100;
					let diff = threshold - current;

					document.querySelectorAll('.cart-freeshipping-threshold-messaging').forEach(item => {
						if (diff > 0) {
							item.innerHTML = `You are $${diff.toFixed(2).replace('.00', '')} away from free shipping`;
						} else if (diff < 0) {
							item.innerText = 'Congrats! Your orders ships free';
						} else {
							item.innerText = `Free Shipping on orders over $${diff.toFixed(2).replace('.00', '')}`;
						}
					});
					// Progress bar
					let progressBar = document.getElementById('minicart-freeshipping-progress-bar');
					if (progressBar && progressBar != null) {
						let percent = Math.min(100, Math.max(0, (current / threshold) * 100));
						progressBar.style.width = percent + '%';
					}
				}

				// free product threshold
				let freeproductThreshold = document.querySelector('[data-freeproduct-threshold]');
				let freeproductID = document.querySelector('[data-freeproduct-id]')?.dataset.freeproductId;
				let freeProduct = minicartContent.querySelector(`[data-item-id="${freeproductID}"]`);

				if (freeproductThreshold) {
					let diff = parseInt(freeproductThreshold.dataset.freeproductThreshold) -
						(data.total_price / 100);
					document.querySelectorAll('.cart-freeproduct-threshold-messaging').forEach(item => {
						if (diff > 0) {
							item.innerHTML = `Spend $${diff.toFixed(2).replace('.00', '')} more and get a FREE Rose Colored Glasses`;
						} else if (diff < 0) {
							item.innerText = 'Congrats! Your free gift is added to your cart';
						} else {
							item.innerText = `Spend $${diff.toFixed(2).replace('.00', '')} and get a FREE Rose Colored Glasses!`;
						}
					});

					if (diff < 0 && !freeProduct && !minicartContent.classList.contains('has-free-product')) {
						minicartContent.classList.add('has-free-product');
						addItem([{
							id: freeproductID,
							quantity: 1
						}]);

					} else if (diff >= 0 && freeProduct) {
						minicartContent.classList.remove('has-free-product');
						changeItemQuantity(freeProduct.dataset.itemLine, 0, true, true, false, () => {
							freeProduct.remove();
						});
					}
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// updates .cart-items HTML
	this.reloadCartItems = () => {
		reloadCartData();

		fetch('/cart')
			.then(response => {
				initLoadingBar('move');
				return response.text();
			})
			.then(data => {
				initLoadingBar('done');

				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');

				// insert the new cart items
				document.querySelectorAll('.cart-items-wrapper').forEach(item => {
					item.innerHTML = dataHtml.querySelector(
						'.cart-items-wrapper'
					).innerHTML;
				});

				// hide upsell if cart items contains the product ID 
				let minicartUpsell = document.querySelectorAll('.minicart-upsell .upsell-product');
				if (minicartUpsell) {
					let minicartProductIds = [];

					document.querySelectorAll('.cart-items-wrapper [data-product-id]').forEach(el => {
						minicartProductIds.push(el.dataset.productId);
					});
					
					minicartUpsell.forEach((upsellProduct) => {
						if (minicartProductIds.includes(upsellProduct.dataset.minicartUpsellId)) {
							upsellProduct.classList.add('is-hidden');
						}else{
							upsellProduct.classList.remove('is-hidden');
						}
					});
					
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		items,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 400
	) => {
		initLoadingBar('start');

		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({
				items: items,
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then(response => {
				response.json();
			})
			.then(data => {
				initLoadingBar('move');

				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
						minicartOpen();
					}, minicartOpenDelay)
					: '';
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		line,
		quantity,
		updateCartTotal = true,
		updateCartItems = false,
		minicartOpenDelay = 400,
		callback
	) => {
		fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				line: line,
				quantity: quantity,
			}),
		})
			.then(response => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
						minicartOpen();
					}, minicartOpenDelay)
					: '';

				if (callback) {
					callback();
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	on('body', 'click', '[data-quantity-trigger]', e => {
		let target = e.target.closest('[data-quantity-trigger]');
		let item = e.target.closest('.cart-item');

		if (item) {
			item.querySelectorAll('[name="quantity"]').forEach(item => {
				item.value = target
					.closest('.item-quantity')
					.querySelector('[name="quantity"]').value;
			});

			let quantity = item.querySelector('[name="quantity"]')?.value || 1;

			changeItemQuantity(
				item.dataset.itemLine,
				quantity,
				true,
				false,
				false,
				() => {
					if (quantity == 0) {
						item.remove();
					}
				}
			);
		}
	});

	on('body', 'click', '.js-item-remove', e => {
		let item = e.target.closest('.cart-item');
		initLoadingBar('start');

		if (item) {
			changeItemQuantity(item.dataset.itemLine, 0, true, true, false, () => {
				item.remove();
			});
		}
	});

	on('body', 'click', '[data-quickadd-id]', e => {
		let target = e.target.closest('[data-quickadd-id]');

		let items = [{
			id: target.dataset.quickaddId,
			quantity: target.dataset.quickaddQuantity || 1,
			selling_plan: target.dataset.quickaddSellingPlanId || null,
		}];

		addItem(items);
	});

	// on('body', 'submit', 'form[action="/cart/add"]', e => {
	on('body', 'submit', '.js-cart-add-form', e => {
		e.preventDefault();
		let form = e.target;

		let item = {
			id: form.querySelector('[name="id"]').value,
			quantity: form.querySelector('[name="quantity"]')?.value || 1
		}

		// if item has selling plans 
		let purchaseOption = form.querySelector('[name="purchase_option"]:checked');
		if (purchaseOption) {
			let purchaseOptionSelect = form.querySelector(`[data-selling-group-id="${purchaseOption?.value}"]`);
			let sellingPlanId = purchaseOptionSelect?.value || null;

			item.selling_plan = sellingPlanId;
		}

		let items = [item];

		addItem(items);
	});
};

const initBlogIndex = () => {
	if (document.querySelector('.blog-pagination-next')) {
		let infiniteScroll = new InfiniteScroll('.blog-load-more', {
			path: '.blog-pagination-next',
			append: '.blog-post',
			button: '.blog-load-more-trigger',
			scrollThreshold: false,
			history: false,
		});

		infiniteScroll.on('last', () => {
			let loadMoreTrigger = document.querySelector('.blog-load-more-trigger');

			loadMoreTrigger.style.display = 'inline-block';
			loadMoreTrigger.disabled = true;
			loadMoreTrigger.innerHTML = 'You’ve reached the end';
		});
	}
};

const initAccountGate = () => {
	// account gate
	on('button', 'click', '.js-reset-password-open', (e) => {
		history.pushState(null, null, '#recover');
		root.classList.add('reset-password-is-active');
	});

	on('button', 'click', '.js-reset-password-close', (e) => {
		history.pushState(null, null, ' ');
		root.classList.remove('reset-password-is-active');
	});

	// trigger password recovery form if url contains the hash
	let resetPasswordOpen = document.querySelector('.js-reset-password-open');

	if (location.hash == '#recover' && resetPasswordOpen) {
		resetPasswordOpen.click();
	}
};

// execute pieces and components functions
initAccordions();
initItemQuantity();
initFields();
initFlickitySlider();
initContentLayout();

// execute global and component functions
initPageTransition();
initPageAnimation();
initHeader();
initSearch();
initCart();
reloadCartData();
reloadCartItems();

// execute page specific functions
switch (root.id) {
	case 'template-blog-index':
		initBlogIndex();
		break;

	case 'template-account':
		initAccountGate();
		break;
}

// make visible .avoid-style-flash elements
setTimeout(() => {
	document.querySelectorAll('.avoid-style-flash').forEach(el => {
		el.style.visibility = 'visible';
	});
}, 400);
